import React from "react"
import BlueLink from "../buttons/bluelink"
import WhiteLink from "../buttons/whitelink"
import useSiteMetadata from "../../hooks/sitemetadata"
//import WhiteLink from "../whitelink"

type LinkProps = {
  person: any
  color?: string
}

const FacultyLink: React.FC<LinkProps> = ({ person, color }) => {
  const { paths } = useSiteMetadata()

  const name = `${person.frontmatter.name}${
    person.frontmatter.postNominalLetters !== ""
      ? `, ${person.frontmatter.postNominalLetters}`
      : ""
  }`

  switch (color) {
    case "white":
      return (
        <WhiteLink to={`${paths.facultyPath}/${person.frontmatter.id}`}>
          {name}
        </WhiteLink>
      )
    default:
      return (
        <BlueLink to={`${paths.facultyPath}/${person.frontmatter.id}`}>
          {name}
        </BlueLink>
      )
  }
}

FacultyLink.defaultProps = {
  color: "blue",
}

export default FacultyLink
